import ChatIcon from '@mui/icons-material/Chat';
import { BoxProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import NewAuthImage from 'assets/images/newAuthImage.png';
import { FullPageProgress } from 'components';
import { theme } from 'styles';
import { AuthPageLink } from 'types';

import { PageHeader } from './PageHeader';
import {
  Page,
  PageContentW,
  MobWrapper,
  HeroPanel,
  HeroImage,
  HeroCaption,
  SupportButton,
  SupportIcon,
  MobileSupportIcon,
  SupportLabel,
  MobileSupportButton,
} from './styled';

interface AuthPageWrapperProps {
  children: ReactNode;
  link?: AuthPageLink;
  isLoading?: boolean;
  contentSx?: BoxProps['sx'];
}

export function AuthPageWrapper({
  children,
  isLoading,
  contentSx,
}: AuthPageWrapperProps): ReactElement {
  const { t } = useTranslation();

  return (
    <>
      {isLoading && <FullPageProgress />}
      <Page>
        <PageContentW sx={contentSx}>
          <MobWrapper>
            <PageHeader />
            {children}
            <MobileSupportButton href="mailto:hello@adligo.io">
              <MobileSupportIcon>
                <ChatIcon
                  sx={{ color: theme.palette.white.main, fill: theme.palette.white.main }}
                />
              </MobileSupportIcon>
              <SupportLabel>{t('login.customerSupport')}</SupportLabel>
            </MobileSupportButton>
          </MobWrapper>
        </PageContentW>
        <HeroPanel>
          <HeroImage src={NewAuthImage} alt="" />
          <HeroCaption>{t('authLayout.heroCaption')}</HeroCaption>
          <SupportButton href="mailto:hello@adligo.io">
            <SupportIcon>
              <ChatIcon sx={{ color: theme.palette.white.main, fill: theme.palette.white.main }} />
            </SupportIcon>
            <SupportLabel>{t('login.customerSupport')}</SupportLabel>
          </SupportButton>
        </HeroPanel>
      </Page>
    </>
  );
}

export { AuthPageTitle, AuthSubPageTitle } from './styled';
